module.exports = __webpack_public_path__ + "static/media/Login.3037a6b9.png";